import type { ReactNode } from "react"

export type ChipProps = {
  colorClassName: string
  iconBackgroundClassName: string
  iconClassName: string
  iconSrc: string
  label: ReactNode
}

export function Chip({
  colorClassName,
  iconBackgroundClassName,
  iconClassName,
  iconSrc,
  label,
}: ChipProps) {
  return (
    <span
      className={`inline-flex h-6 max-w-full items-center gap-1.5 overflow-hidden rounded-[13px] border py-1 pr-2.5 pl-[5px] ${colorClassName}`}
    >
      <span className={`grid h-4 w-4 shrink-0 place-items-center rounded-lg ${iconBackgroundClassName}`}>
        <img alt="" className={`block ${iconClassName}`} src={iconSrc} />
      </span>
      <span className="truncate text-[11.5px] font-medium [line-height:normal]">{label}</span>
    </span>
  )
}
